import React, { FC, useCallback } from "react";
import {
  StringSetting,
  useUserSettingWithDefault,
} from "shared-ts-utils-user-settings";
import { WhatsNewPage } from "./WhatsNewPage";
import { NavigationLessAppPage } from "shared-ts-ui-app-boot";
import { useAppInfo } from "shared-ts-app-info";
import { useLanguage } from "shared-ts-language";
import { useTranslation } from "react-i18next";

export class WhatsNewProviderProps {
  children: React.ReactNode;
}

export const WhatsNewProvider: FC<WhatsNewProviderProps> = (props) => {
  const appInfo = useAppInfo();
  const { t } = useTranslation("chimney-insights-ts-translations");
  const { language, setLanguage } = useLanguage();
  const [lastReadRelease, setLastReadRelease] = useUserSettingWithDefault(
    "AppInfo.release",
    StringSetting,
    null
  );
  const showWhatsNew =
    lastReadRelease === null || lastReadRelease !== appInfo.release;

  const handleWhatsNewPageClose = useCallback(() => {
    setLastReadRelease(appInfo.release);
  }, [appInfo.release, setLastReadRelease]);

  if (!showWhatsNew) {
    return props.children;
  }

  return (
    <NavigationLessAppPage
      appInfo={appInfo}
      language={language}
      onLanguageChange={setLanguage}
    >
      <WhatsNewPage onClose={handleWhatsNewPageClose} />
    </NavigationLessAppPage>
  );
};
